<template>
  <custom-section :section="section">
    <template #top>
      <customer v-if="isCustomerVisible"></customer>
      <select-prospect></select-prospect>
      <select-activity-type></select-activity-type>
      <select-opportunity></select-opportunity>
      <select-stage v-if="hasStageSelector"></select-stage>
      <select-task v-if="user.crmRequired"></select-task>
    </template>
    <template #bottom>
      <subject-input></subject-input>
      <summary-input></summary-input>
      <log-crm-toggle v-if="hasLogToCrmToggle"></log-crm-toggle>
      <slot></slot>
    </template>
  </custom-section>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Customer from "./customer";
import SelectActivityType from "./select-activity-type";
import SelectProspect from "./select-prospect";
import SelectOpportunity from "./select-opportunity";
import SelectTask from "./select-task";
import SubjectInput from "./subject-input";
import SelectStage from "./select-stage";
import SummaryInput from "./summary-input";
import CustomSection from "../custom-section/custom-section";
import LogCrmToggle from "./log-crm-toggle";

const { mapGetters, mapState } = createNamespacedHelpers("activitySummary");

export default {
  components: {
    Customer,
    SelectActivityType,
    SelectProspect,
    SelectOpportunity,
    SelectTask,
    SubjectInput,
    SelectStage,
    SummaryInput,
    CustomSection,
    LogCrmToggle,
  },
  props: ["section"],
  data() {
    return {
      team: this.$_activitySummary_config.getTeam(),
      user: this.$_activitySummary_config.getUser(),
    };
  },
  computed: {
    ...mapState(["activity"]),
    ...mapGetters(["hasActivity"]),
    hasDialpad() {
      return this.team.features.find(
        (feature) => feature.name === "DIALER_DIALPAD"
      );
    },
    isCustomerVisible() {
      // Customer field is only visible for softphone
      if (this.activity.type === "conference") {
        return false;
      }

      // If crm toggle for selecting the lead, account
      // and contact is enabled hide the customer field
      const { crm } = this.$_activitySummary_config.getTeam();
      if (crm.softphoneOverrideProspect) {
        return false;
      }

      // If an unknown prospect is called from the dialpad
      // then don't show the customer field
      if (!this.activity.prospect) {
        return false;
      }

      // Otherwise show the field
      return true;
    },
    hasStageSelector() {
      return (
        ![
          "Pleo",
          "Informa",
          "Trilio",
          "Boardworks Education",
          "Rotageek",
          "Sendcloud",
          "Victorious",
          "Fresh Relevance",
        ].includes(this.team.name) && this.user.crmRequired
      );
    },
    hasLogToCrmToggle() {
      return (
        (this.hasDialpad ||
          ["conference", "softphone-inbound"].includes(this.activity.type)) &&
        this.user.crmRequired
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// activity-summary-section.vue?690f47ae